import { getClient, getIndexOfStep } from '../../../../lib/info';
import { selectedType } from '../../../../store/appointment-type';
import { useAppSelector } from '../../../../store/hooks';
import { getAppointmentId } from '../../../../store/page';
import { selectedPointOfSale } from '../../../../store/point-of-sale';

// Gate dello Smart multi-store. Solo aziende FOCUS CLOUD: il flag arriva dal backend già
// risolto (insegna abilitata, licenza FOCUS CLOUD, più di un centro ottico). Le altre aziende
// mantengono il comportamento precedente: nessun componente nuovo e nessuna chiamata nuova.
// Spento anche senza lo step "dove", con centro od operatore fissati dal link e in modifica.
export const useSmartMultiStore = (): boolean => {
  const {
    company: { isSmartMultiStoreActive },
    isPointOfSaleOrUserFixedByLink,
  } = getClient();
  const appointmentId = useAppSelector(getAppointmentId);
  const { id: serviceId } = useAppSelector(selectedType);
  const { id: pointOfSaleId } = useAppSelector(selectedPointOfSale);

  return (
    isSmartMultiStoreActive === true &&
    getIndexOfStep('dove') !== -1 &&
    isPointOfSaleOrUserFixedByLink !== true &&
    appointmentId === undefined &&
    serviceId !== undefined &&
    serviceId !== '' &&
    pointOfSaleId !== undefined &&
    pointOfSaleId !== ''
  );
};
